import { FC } from 'react';
import { CollapseProps } from '$uikit/Collapse/Collapse.interface';
import { IcDropdown16 } from '$assets';
import './Collapse.sass';
import { classNames } from '$utils';
import { useTranslator } from '$hooks';

export const Collapse: FC<CollapseProps> = ({
  children,
  title,
  isOpen,
  subTitle,
  onClick,
  className,
  isReversed,
  hideTitleOnOpen,
}) => {
  const t = useTranslator();

  const CollapseHeader = () => (
    <div className="Collapse__header" onClick={() => onClick(!isOpen)}>
      <span className="Collapse _title">
        {isOpen && hideTitleOnOpen ? t('collapse_title') : title}
      </span>
      <div className="Collapse__header__leftContent">
        {subTitle && !(isOpen && hideTitleOnOpen) && (
          <span className="Collapse _title _subTitle">{subTitle}</span>
        )}
        <div className="Collapse__header__icon">
          <IcDropdown16 />
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`${classNames({
        Collapse: true,
        isOpen,
      })} ${className}`}
    >
      {!isReversed && <CollapseHeader />}
      <div className="Collapse__content">{children}</div>
      {isReversed && <CollapseHeader />}
    </div>
  );
};
